exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bg-img1{background-image:url(" + require("../img-layout/bg1.jpg") + ");background-size:cover}.bg-img1,.bg-img2{background-repeat:no-repeat}.bg-img2{background-image:url(" + require("../img-layout/bg2-white-opacity.jpg") + ");background-size:100% auto;background-position:50%}@media only screen and (max-width:61em){.bg-img2{background-image:url(" + require("../img-layout/bg2-white-opacity.jpg") + ");background-repeat:no-repeat;background-size:100% auto;background-position:bottom}}.bg-img3{background-image:url(" + require("../img-layout/bg3.jpg") + ");background-repeat:no-repeat;background-size:100% auto;background-size:cover}.bg-blue,.bg-img1,.bg-img2,.bg-img4{overflow:hidden}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/styles/index.less
 ** module id = 480
 ** module chunks = 1
 **/